exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip-vue {\n  background-color: #27282bb2;\n}\n.tooltip-vue-inner {\n  padding: 5px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/App.vue?vue&type=style&index=0&lang=css&
// module id = SKi9
// module chunks = 35